import tinyColor from "tinycolor2";
import { DivProps } from "../../../../../globalTypes";
import styled from "../../../../../config/emotion";

type ColorBoxProps = DivProps & { color?: string };
export const ColorBox = styled.div<ColorBoxProps>`
  display: inline-block;
  padding: 2px 10px;
  color: ${(props) => props.color ?? "black"};
  border-radius: 4px;
  background-color: ${(props) => tinyColor(props.color).lighten(40).toString()};
`;
